const dashboard = [
  {
    path: '/dashboards/crm',
    name: 'dashboard-crm',
    component: () => import('@/views/dashboards/crm/Crm.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,network-systems',
    },
  },
  {
    path: '/dashboards/analytics',
    name: 'dashboard-analytics-xpto',
    component: () => import('@/views/dashboards/crm/Crm.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,network-systems',
    },
  },
  {
    path: '/dashboards/eCommerce',
    name: 'dashboard-eCommerce',
    component: () => import('@/views/dashboards/ecommerce/Ecommerce.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,network-systems',
    },
  },
]

export default dashboard
